module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-pdf-fill-eb34ed07.svg";